export default "__VITE_ASSET__00821bf3__"